
import React from 'react';
import { getUploadedFile, currencyFormat, displayPan } from "../../../../../helpers/utilities";
import moment from 'moment';
import { SalesLines } from "./inc/SalesComponents";


export const SBP = React.forwardRef((props, ref) => {
    const { businessDetails, details, preview, proformaPreview, copy } = props;

    const address = (details) => {
        let address = details?.address || details?.address1 || '';
        address += address !== '' ? ', ' : '';
        address += details?.area && details?.area?.name ? details?.area?.name : '';
        return address;
    }

    const address1 = (details) => {
        let address = details?.city && details?.city?.name ? details?.city?.name + ' - ' : '---';
        address += details?.pincode && details?.pincode?.code ? details?.pincode?.code : '---';
        address += details?.state && details?.state?.name ? ', ' + details?.state?.name : '---';
        address += details?.country && details?.country?.name ? ', ' + details?.country?.name : '---';
        return address;
    }

    const discountAmount = (items) => {
        const safeItems = items ?? [];
if (!safeItems.length) return 0;
        let totalDiscount = Number(details?.cashDiscountAmount || 0);
        for (const v of items) {
            const qty = Number(v.quantity || 0);
            const price = Number(v.pricePerUnit || 0);
            const discountAmt = Number(v.discountAmount || 0);
            const discountPercent = Number(v.discountPercent || 0);

            // Line-level fixed discount
            totalDiscount += discountAmt;

            // Percentage discount
            const percentDiscount = ((qty * price) * discountPercent) / 100;

            if (v.amount < 0) {
                totalDiscount -= percentDiscount;
            } else {
                totalDiscount += percentDiscount;
            }
        }

        return Number(totalDiscount.toFixed(2));
    }
    return (
        <div className="sbp_bill" style={{ fontFamily: "Roboto" }}>
            <div>
                <div style={{ width: "100%", padding: 10, backgroundColor: "#1c314c" }} />
                <div style={{ padding: "10px 12px", position: "relative", marginTop: 5, backgroundColor: "#ffc27a", display: "flex" }}>
                    <div style={{ color: "#000000", width: "55%", display: "inline-block", lineHeight: "1.5715", fontSize: 20, fontWeight: 500, textAlign: "right" }}>
                        {
                            proformaPreview ? 'Proforma' : <>
                                {
                                    preview || details?.invoiceAmount >= 0 ?
                                        `${details?.selfBill?.includeGst ? 'Tax Invoice' : 'Invoice'}` :
                                        'Credit Note'
                                }
                            </>
                        }
                    </div>
                    {
                        !proformaPreview && <div style={{ color: "#000000", width: "45%", display: "inline-block", lineHeight: "1.5715", textAlign: "right", fontSize: 20, fontWeight: 500, paddingLeft: 20 }}>
                            {`${copy ? copy : 'Original'}`}
                        </div>
                    }
                </div>
            </div>
            <div style={{ border: "1px solid #000000", borderTop: "none" }}>
                <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                    <div style={{ width: "20%", display: "inline-flex" }}>
                        {
                            (businessDetails?.logoUri || details?.business?.logoUri) &&
                            <img
                                src={getUploadedFile(businessDetails?.logoUri)}
                                alt="logo"
                                style={{ height: 200, width: "100%", objectFit: "contain", padding: 10 }}
                            />
                        }
                    </div>
                    <div style={{ width: (businessDetails?.logoUri || details?.business?.logoUri) ? "80%" : "100%", display: "inline-block" }}>
                        <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                            <div style={{ width: "50%", display: "inline-block", borderRight: "1px solid #000000", padding: "12px 12px 0 12px" }}>
                                <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                    Bill From
                                </h6>
                                <h1 style={{ lineHeight: "1.22", color: "#000", fontWeight: 500, fontSize: 19 }}>
                                    {
                                        preview ? <span style={{ width: "50%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : businessDetails?.businessName || details?.business?.name || '---'
                                    }
                                </h1>
                                <div style={{ marginTop: 10, color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15" }}>
                                    <p style={{ marginBottom: 7 }}>
                                        {
                                            preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : address(businessDetails || details?.business)
                                        }
                                    </p>
                                    <p style={{ marginBottom: 7 }}>
                                        {
                                            preview ? <span style={{ width: "50%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : address1(businessDetails || details?.business)
                                        }
                                    </p>
                                </div>
                            </div>
                            <div style={{ width: "50%", display: "inline-block", padding: "12px 12px 0 12px" }}>
                                <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                    Bill To
                                </h6>
                                <h2 style={{ lineHeight: "1.22", color: "#000", fontWeight: 500, fontSize: 19 }}>
                                    {
                                        preview ? <span style={{ width: "50%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.name || details?.customerName || '---'
                                    }
                                </h2>
                                <div style={{ marginTop: 10, color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15" }}>
                                    <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                        {
                                            preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : address(details?.customer)
                                        }
                                    </p>
                                    <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                        {
                                            preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : address1(details?.customer)
                                        }
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                            <div style={{ width: "50%", display: "inline-block", borderRight: "1px solid #000000", padding: 12 }}>
                                <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                                    <div style={{ width: "100%", display: "block" }}>
                                        <div
                                            style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                                            <div style={{ width: "15%", display: "inline-block", verticalAlign: "middle" }} >
                                                <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                                    Email
                                                </h6>
                                            </div>
                                            <div style={{ width: "85%", display: "inline-block", verticalAlign: "middle" }}>
                                                <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }} >
                                                    {
                                                        preview ? <span style={{ width: "50%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : businessDetails?.email || details?.business?.email || '---'
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ width: "50%", display: "inline-block" }}>
                                        <div
                                            style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }} >
                                            <div style={{ width: "30%", display: "inline-block", verticalAlign: "middle" }}>
                                                <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                                    Ph No.
                                                </h6>
                                            </div>
                                            <div style={{ width: "70%", display: "inline-block", verticalAlign: "middle" }}>
                                                <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                                    {
                                                        preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : businessDetails?.mobile || details?.business?.mobile || '---'
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        (details?.selfBill?.includeGst || preview) &&
                                        <div style={{ width: "50%", display: "inline-block" }}>
                                            <div
                                                style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }} >
                                                <div style={{ width: "30%", display: "inline-block", verticalAlign: "middle" }}>
                                                    <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                                        GSTIN
                                                    </h6>
                                                </div>
                                                <div style={{ width: "70%", display: "inline-block", verticalAlign: "middle" }}>
                                                    <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7, whiteSpace: "nowrap" }}>
                                                        {
                                                            preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : businessDetails?.gst || details?.business?.gstNumber || '---'
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {
                                        (businessDetails?.pan || details?.business?.panNumber) &&
                                        <div style={{ width: "100%", display: "block" }}>
                                            <div
                                                style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                                                <div style={{ width: "15%", display: "inline-block", verticalAlign: "middle" }} >
                                                    <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                                        {displayPan(businessDetails?.pan || details?.business?.panNumber || '')[0]}
                                                    </h6>
                                                </div>
                                                <div style={{ width: "85%", display: "inline-block", verticalAlign: "middle" }}>
                                                    <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }} >
                                                        {
                                                            preview ? <span style={{ width: "50%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : displayPan(businessDetails?.pan || details?.business?.panNumber || '')[1]
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div style={{ width: "50%", display: "inline-block", padding: 12 }}>
                                <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                                    <div style={{ width: "100%", display: "block" }}>
                                        <div
                                            style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                                            <div style={{ width: "15%", display: "inline-block", verticalAlign: "middle" }} >
                                                <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                                    Email
                                                </h6>
                                            </div>
                                            <div style={{ width: "85%", display: "inline-block", verticalAlign: "middle" }}>
                                                <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }} >
                                                    {
                                                        preview ? <span style={{ width: "50%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.customer?.email || '---'
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ width: "50%", display: "inline-block" }}>
                                        <div
                                            style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }} >
                                            <div style={{ width: "30%", display: "inline-block", verticalAlign: "middle" }}>
                                                <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                                    Ph No.
                                                </h6>
                                            </div>
                                            <div style={{ width: "70%", display: "inline-block", verticalAlign: "middle" }}>
                                                <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                                    {
                                                        preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.customer?.mobile || '---'
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        (details?.selfBill?.includeGst || preview) &&
                                        <div style={{ width: "50%", display: "inline-block" }}>
                                            <div
                                                style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }} >
                                                <div style={{ width: "30%", display: "inline-block", verticalAlign: "middle" }}>
                                                    <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                                        GSTIN
                                                    </h6>
                                                </div>
                                                <div style={{ width: "70%", display: "inline-block", verticalAlign: "middle" }}>
                                                    <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }}>
                                                        {
                                                            preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.customer?.gstin || '---'
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {
                                        details?.customer?.pan &&
                                        <div style={{ width: "100%", display: "block" }}>
                                            <div
                                                style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                                                <div style={{ width: "15%", display: "inline-block", verticalAlign: "middle" }} >
                                                    <h6 style={{ color: "#000000", fontSize: 15, fontWeight: 500, lineHeight: "1.15", marginBottom: 7 }}>
                                                        {displayPan(details?.customer?.pan)[0]}
                                                    </h6>
                                                </div>
                                                <div style={{ width: "85%", display: "inline-block", verticalAlign: "middle" }}>
                                                    <p style={{ color: "#000000", fontSize: 15, fontWeight: 400, lineHeight: "1.15", marginBottom: 7 }} >
                                                        {
                                                            preview ? <span style={{ width: "50%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : displayPan(details?.customer?.pan)[1]
                                                        }
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ borderTop: "1px solid #000000", padding: 12 }}>
                    <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
                        <div style={{ width: "25%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                {preview || proformaPreview || details?.invoiceAmount >= 0 ? 'Invoice Number' : 'Credit Note'}
                            </h6>
                            <h2 style={{ color: "#000", fontSize: 18, fontWeight: 500, marginBottom: 0, lineHeight: "1.22" }}>
                                {details?.salesInvoice?.serialNo || details?.serialNo || '---'}
                            </h2>
                        </div>
                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                Invoice Date
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 0, display: "block" }}>
                                {
                                    preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.invoiceDate ? moment(details.invoiceDate).format('DD MMM YYYY') : '---'
                                }
                            </p>
                        </div>
                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }} >
                                Due Date
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 0, display: "block" }}>
                                {
                                    preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.dueDate ? moment(details.dueDate).format('DD MMM YYYY') : '---'
                                }
                            </p>
                        </div>
                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                Invoice Amount
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 0, display: "block" }}>
                                {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : `${currencyFormat(details?.invoiceAmount ? details?.invoiceAmount : 0)}`}
                            </p>
                        </div>
                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                Net Amount
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 0, display: "block" }}>
                                {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : `${currencyFormat(details?.salesInvoiceItems ? details?.invoiceAmount - (details?.roundOffAmount || 0) - details?.salesInvoiceItems.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0) : 0)}`}
                            </p>
                        </div>
                        {
                            details?.roundOffAmount !== 0 ? <div style={{ width: "12.5%", padding: "0 3px" }}>
                                <h6
                                    style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                    Round Off
                                </h6>
                                <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 0, display: "block" }}>
                                    {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.roundOffAmount}
                                </p>
                            </div> : ''
                        }

                        {
                            details?.selfBill?.includeGst && <div style={{ width: "12.5%", padding: "0 3px" }}>
                                <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                    GST Amount
                                </h6>
                                <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 0, display: "block" }}>
                                    {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : `${currencyFormat(details?.salesInvoiceItems ? details?.salesInvoiceItems.reduce((a, v) => a = parseFloat(a) + parseFloat(v.gstAmount), 0) : 0)}`}
                                </p>
                            </div>
                        }
                    </div>
                    <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", marginTop: 15 }}>
                        <div style={{ width: "25%", padding: "0 3px" }}>
                            {
                                details?.reference ? <>
                                    <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                        Reference
                                    </h6>
                                    <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, marginBottom: 0, lineHeight: "1.15", display: "block" }}>
                                        {details?.reference || '---'}
                                    </p></> : ''
                            }
                        </div>
                        {
                            (details?.fromDate || details?.toDate) &&
                            <div style={{ width: "25%", padding: "0 3px" }}>
                                <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                    Service Date
                                </h6>
                                <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, marginBottom: 0, lineHeight: "1.15", display: "block" }}>
                                    {details.fromDate && moment(details.fromDate).format('DD MMM YYYY')}{details.toDate && (details.toDate !== details.fromDate) && ` to ${moment(details.toDate).format('DD MMM YYYY')}`}
                                </p>
                            </div>
                        }
                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                Place of Supply
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, marginBottom: 0, lineHeight: "1.15", display: "block" }}>
                                {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.state?.name || '---'}
                            </p>
                        </div>
                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                Pmt. Method
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, marginBottom: 0, lineHeight: "1.15", display: "block" }}>
                                {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.mop?.method || '---'}
                            </p>
                        </div>
                        <div style={{ width: "12.5%", padding: "0 3px" }}>
                            <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                Currency
                            </h6>
                            <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, marginBottom: 0, lineHeight: "1.15", display: "block" }}>
                                {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : details?.currency?.name || '---'}
                            </p>
                        </div>
                        {
                            discountAmount(details?.salesInvoiceItems) > 0 &&
                            <div style={{ width: "12.5%", padding: "0 3px" }}>
                                <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                    Total Discount
                                </h6>
                                <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, marginBottom: 0, lineHeight: "1.15", display: "block" }}>
                                    {preview ? <span style={{ width: "70%", height: "16px", backgroundColor: "#ececec", display: "inline-block" }}></span> : `${currencyFormat(discountAmount(details?.salesInvoiceItems))}`}
                                </p>
                            </div>
                        }
                    </div>
                </div>
                {
                    (details?.dispatchDetails || details?.comments) &&
                    <div style={{ display: "flex", borderTop: "1px solid #000000" }}>
                        {
                            details?.dispatchDetails ? <div style={{ width: "30%", padding: "10px 15px 3px" }}>
                                <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }} >
                                    Dispatch Details
                                </h6>
                                <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                    {details?.dispatchDetails || '---'}
                                </p>
                            </div> : ''
                        }
                        {
                            details?.comments ?
                                <div style={{ width: details?.dispatchDetails ? "70%" : "100%", padding: "10px 15px 3px", borderLeft: "1px solid #000000" }}>
                                    <h6 style={{ fontSize: 15, color: "#000000", fontWeight: 500, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                        Comments
                                    </h6>
                                    <p style={{ fontSize: 15, color: "#000000", fontWeight: 400, lineHeight: "1.15", marginBottom: 7, display: "block" }}>
                                        {details?.comments || '---'}
                                    </p>
                                </div> : ''
                        }
                    </div>
                }
                <SalesLines ref={ref} {...props} terms={true} />
            </div>
        </div>
    )
})